export default __webpack_public_path__ + "static/media/error.0890843e.svg";